import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { UButtonGroupComponent, ChangeModule } from '@updater/angular-common';
import { ShareMoveCustomizeConfig } from './customize.config';
import { ShareMoveCustomizeComponent } from './customize.component';
import {
  UCloudinaryImageDirectives,
  GoogleMapModule,
  RelevantContentComponent,
  StepPageModule,
} from '../../../common/directives';
import '@updater-components/radio-group';

export const ShareMoveCustomizeModule = angular
  .module('app.steps.share-move.customize', [
    uiRouter,
    UCloudinaryImageDirectives.name,
    GoogleMapModule.name,
    RelevantContentComponent.name,
    StepPageModule.name,
    UButtonGroupComponent.name,
    ChangeModule.name,
  ])
  .config(ShareMoveCustomizeConfig)
  .component('updShareMoveCustomize', ShareMoveCustomizeComponent);
